import { COUNTRY_CODES } from "./constants/Countries";

export enum INTEGRATION_PROPS {
  GOOGLE_UNIVERSAL_ANALYTICS = "Google Universal Analytics"
}

export enum FORM_TYPE {
  LOGIN = "login",
  REGISTER = "register",
  FORGOT = "forgot"
}

export const STRIPE_PRODUCTS_COLLECTIONS = {
  [COUNTRY_CODES.SG]: "stripeProducts",
  [COUNTRY_CODES.HK]: "stripeProductsHK",
  [COUNTRY_CODES.JP]: "stripeProductsJP"
};
